import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";
import { RouterProvider } from "react-router-dom";

import { GoogleRecaptchaProvider } from "./app/providers/GoogleRecaptchaProvider";
import { router } from "./app/providers/router";
import TanstackProvider from "./app/providers/TanstackProvider";
import "./shared/config/i18n";

import "./app/styles/index.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
    throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
    <React.StrictMode>
        <HelmetProvider>
            <TanstackProvider>
                <GoogleRecaptchaProvider>
                    <RouterProvider router={router} />
                    <Toaster containerStyle={{ width: "100%" }} toastOptions={{ removeDelay: 0 }} />
                </GoogleRecaptchaProvider>
            </TanstackProvider>
        </HelmetProvider>
    </React.StrictMode>,
);
